export default __webpack_public_path__ + "static/Kalam-Regular-cff63bfb39ab810c38112b2eef3dd200.woff2";